<template>
    <div>
        <label class="typo__label" v-if="label">{{label}}</label>
        <multiselect
            v-model="value"
            label="val"
            track-by="key"
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
            :placeholder="placeholder"
            :options="options"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false"
            :limit="0"
            :limit-text="limitText"
        >
            <template slot="option" slot-scope="props">
                <img v-if="isSelected(props.option.key)" class="icon-checkbox" src="/assets/images/gov_sprites.png" alt="aws">
                <img v-else class="icon-uncheck" src="/assets/images/gov_sprites.png" alt="aws">&nbsp;</img>
                <img v-if="props.option.vendor === 'aws'" class="icon-aws" src="/assets/images/gov_sprites.png" alt="aws">
                <img v-if="props.option.vendor === 'azure'"  class="icon-azu" src="/assets/images/gov_sprites.png" alt="azu">
                <img  v-if="props.option.vendor === 'gcp'" class="icon-gcp" src="/assets/images/gov_sprites.png" alt="gcp">
                <span class="option-title">{{props.option.val}}</span>
            </template>
        </multiselect>
    </div>    
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: {
        Multiselect
    },
    props: {
        options: {
            type: Array,
            default: ()=>[]
        },
        placeholder: {
            type: String,
            default: 'placeholder'
        },
        label: {
            type: String,
            default: null
        },
        callOnSelect: {
            type: Function,
            default: ()=>{}
        },
        preSelected: {
            type: Array,
            default: ()=>[]
        }
    },
    mounted() {
        if (this.preSelected.length > 0) {
            this.value = this.preSelected;
        }
    },
    data () {
        return {
            value: [],
            taggable: false,
        }
    },
    watch: {
        value(newVal) {
            const selectedKeys = newVal.map(options => {return options.key})
            this.callOnSelect(selectedKeys);
        },
        options(newVal, oldVal) {
            const difference = _.difference (newVal, oldVal);
            if (newVal.length == 0 || difference.length != 0) {
                this.value = [];
            }
        }
    },
    methods: {
        isSelected(title) {
            const selectedValues = this.value.map((opt)=>{return opt.key})
            return selectedValues.indexOf(title) != -1;
        },
        limitText() {
            return `${this.placeholder} ${this.value.length}/${this.options.length}`;
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
/deep/ .multiselect__select:before {
    top: 85%;
    border-width: 6px 5px 0;
    right: 3px;
}
/deep/ .multiselect__content-wrapper{
    min-width: 300px;
    border-radius: 4px;
}
/deep/ .multiselect__tags {
    font-size: 12px;
    padding-left: 12px;
    padding-top: 5px;
    height: 32px;
    min-height: unset;
}
/deep/ .multiselect__single {
    display: none;
}
/deep/ span.multiselect__option {
    line-height: 0;
}
.multiselect__option .option-title {
    font-size: 12px;
    vertical-align: top;
}
/deep/ .multiselect__option--highlight {
    background: #F3F4F5;
    outline: inherit;
    color: inherit;
}
.icon-uncheck {
    content: '';
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 7;
    height: 15px;
    width: 15px;
    vertical-align: middle;
    border: 1px solid #D5D9DB;
    border-radius: 2px;
    background-color: #fff;
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
    padding: 7px;
}
.icon-checkbox {
    border: 0;
    background-color: #1886FF;
    background-image: url(/assets/images/gov_sprites.png);
    background-position: -84px -118px;
    width: 15px;
    height: 15px;
    padding: 7px;
}
.icon-aws {
    background-image: url(/assets/images/gov_sprites.png);
    background-position: -28px -118px;
    width: 15px;
    height: 15px;
    padding: 7px;
}
.icon-azu {
    background-image: url(/assets/images/gov_sprites.png);
    background-position: -128px -56px;
    width: 15px;
    height: 15px;
    padding: 7px;
}
.icon-gcp {
    background-image: url(/assets/images/gov_sprites.png);
    background-position: -56px -118px;
    width: 15px;
    height: 15px;
    padding: 7px;
}
/deep/ input.multiselect__input {
    font-size: 12px;
	margin: 0;
}
/deep/ .multiselect__select {
	top: unset;
	height: 25px;
	width: 0;
	right: 18px;
	padding: 0;
}
/deep/ .multiselect--active .multiselect__select {
	transform: rotateX(180deg);
}

</style>


// WEBPACK FOOTER //
// src/components/common/OptionSelect/CVendorSelect.vue